import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import DataTable from 'Common/Table/DataTable';
import Panel from 'Common/Layout/Panel';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';

import styles from './ReadyToCheck.module.css';

const ReadyToCheckView = ({
    year,
    updateYear,
    grouping,
    contracts,
    title,
    schema,
    keyField,
    onContractSelect,
    currentContract,
    onCellChange,
    onCellClick,
    componentProps,
    validationResult,
    isLoaded
}) => {

    return (
        <Page title={title} fitScreen>
            <Section>
                <h3 class="sr-only">Search</h3>
                <Panel title="Select Year">
                    <YearSelector grouping={grouping} updateYear={updateYear} year={year} numberOfFutureYears={1} />
                </Panel>
            </Section>
            {contracts.length > 0 && (
                <Section>
                    <h3 class="sr-only">Search Results</h3>
                    <DataTable
                        dataSource={contracts}
                        keyField={keyField}
                        schema={schema}
                        pagination
                        selection={true}
                        selected={currentContract}
                        onSelectionChange={onContractSelect}
                        onCellChange={onCellChange}
                        onCellClick={onCellClick}
                        componentProps={componentProps}
                    />
                </Section>
            )}
            <SuccessFailure { ...validationResult } />
            {
                contracts.length === 0 && isLoaded && (<div className={styles['no-data']}> 
                                                            <Typography variant="h3">No Appointments available at status Ready</Typography>
                                                       </div>)
            }
        </Page>
    );

};

export default ReadyToCheckView;

ReadyToCheckView.propTypes = {
    year: PropTypes.string.isRequired,
    updateYear: PropTypes.func.isRequired,
    grouping: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    keyField: PropTypes.string.isRequired,
    onContractSelect: PropTypes.func.isRequired,
    currentContract: PropTypes.any,
    onCellChange: PropTypes.func,
    onCellClick: PropTypes.func,
    componentProps: PropTypes.object,
    validationResult: PropTypes.object,
    isLoaded: PropTypes.bool.isRequired
};